export default __webpack_public_path__ + "static/omnibar-concept-light-0c2cf4b64505b438a3e02eb46036a626.mp4";